import React, {useState, useEffect} from 'react'
import Pay from './Internship/Pay'
import Stk from './Internship/Stk';
import Fill_in from './Internship/Fill_in';
import Attachment_document from './Internship/Upload_IMG/Attachment_document';
import Back_ID from './Internship/Upload_IMG/Back_ID';
import Front_ID from './Internship/Upload_IMG/Front_ID';
import Cv from './Internship/Upload_IMG/Cv';

function Internship({ms}) {
   const [pay, setPay] = useState(false);
   const [stk, setStk] = useState(false);
   const [fillin, setFillin] = useState(true) 
   const [doc, setDoc] = useState(false)
   const [Backid, setBackid] = useState(false)
   const [frontid, setFrontid] = useState(false)
   const [cv, setCv] = useState(false)

  return (
    <div className='others_div'>
       {stk?(<div className='inner_Other'>
        <Stk 
        setPay={setPay} 
        setStk={setStk}
        setFillin={setFillin}
        setDoc={setDoc}
        setBackid={setBackid}
        setFrontid={setFrontid}
        ms={ms}
        />
        </div>):('')}
       {fillin?(<div className='inner_Other'>
        <Fill_in
           setPay={setPay} 
           setStk={setStk}
           setFillin={setFillin}
           setDoc={setDoc}
           setBackid={setBackid}
           setFrontid={setFrontid}
        /></div>):('')}
       {doc?(<div className='inner_Other'>
        <Attachment_document 
          setPay={setPay} 
          setStk={setStk}
          setFillin={setFillin}
          setDoc={setDoc}
          setBackid={setBackid}
          setFrontid={setFrontid}
       /></div>):('')}
       {Backid?(<div className='inner_Other'>
        <Back_ID 
           setPay={setPay} 
           setStk={setStk}
           setFillin={setFillin}
           setDoc={setDoc}
           setBackid={setBackid}
           setFrontid={setFrontid}
           setCv={setCv}
           ms={ms}
        /></div>):('')}
        {cv?(<div className='inner_Other'>
         <Cv setCv={setCv} setDoc={setDoc} />
        </div>):('')}
       {frontid?(<div className='inner_Other'>
        <Front_ID 
           setPay={setPay} 
           setStk={setStk}
           setFillin={setFillin}
           setDoc={setDoc}
           setBackid={setBackid}
           setFrontid={setFrontid}
        /></div>):('')}
    </div>
  )
}

export default Internship
